import React, { useState,useEffect } from "react";
import axios from 'axios';
import { ChangeMobileFormat, GetPaymentStatus,PassedMonthsCode, addThousandPoint,GetPaymentDate,GetPaymentClassStatus,isObjEmpty } from "../../../components/common/Common";

//기존 결제 내역 (최근 1년)
const PaymentHisotry = ({varShowPaymentHistory,varPaymentHistoryInfo,setShowPaymentHistory}) => {

  const [varPaymentInfo,setPaymentInfo] = useState({});
  const [varPaymentList,setPaymentList] = useState([]);

  //기존 결제 내역 (최근 1년)
  const onPaymentLastYearListHandler = async(e) => {
    setShowPaymentHistory(true);
    const sendData = {ph_idx:varPaymentHistoryInfo.ph_idx,ch_idx:varPaymentHistoryInfo.ch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_payment_history`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //선택한 결제 정보
        setPaymentInfo(datas.payments[0]);
        //결제 내역
        setPaymentList(datas.historys);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    if(!isObjEmpty(varPaymentHistoryInfo)) onPaymentLastYearListHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPaymentHistoryInfo]);

  return isObjEmpty(varPaymentHistoryInfo)?null:(
    <div className={varShowPaymentHistory?"layer__pop open":"layer__pop"}>
      <div className="layer__pop__confirm" style={{maxWidth:"500px"}}>
        <div className="layer__bottom__head mb15">
          <div className="layer__pop__title" style={{paddingTop:"20px"}}>기존 결제 내역(최근 1년)</div>
          <div className="layer__pop__close" onClick={()=>setShowPaymentHistory(false)}></div>
        </div>
        <div className="layer__pop__body" style={{marginTop:"10px"}}> 
          <div className="main-box">
            <div className="payment-view-wrap">
              <div className="center-wrap">
                <div className="view-list">
                  <div className="view-con">
                    <div className="date-line">
                      <div className="date">{GetPaymentDate(varPaymentInfo)}</div>
                      <p className="price">₩ {addThousandPoint(varPaymentInfo.ph_price)} 원</p>
                    </div>
                    <div className="info-line">{varPaymentInfo.mem_name} {ChangeMobileFormat(varPaymentInfo.mem_mobile)} <span> 👼🏻[{varPaymentInfo.ch_name}({PassedMonthsCode(varPaymentInfo.ch_birthday)})]</span></div>
                    <div className="flex">
                      <p>결제 유형</p>
                      <div>카드</div>
                    </div>
                    <div className="flex">
                      <p>결제 학기</p>
                      <div>{varPaymentInfo.sm_name}</div>
                    </div>
                    <div className="flex">
                      <p>결제 클래스</p>
                      <div>{varPaymentInfo.cl_name}</div>
                    </div>
                    <div className="flex">
                      <p>청구서 ID</p>
                      <div>{varPaymentInfo.ivc_id}</div>
                    </div>
                    <div className="flex">
                      <p>결제 상태</p>
                      <div className={GetPaymentClassStatus(varPaymentInfo.ph_status)}>
                        {GetPaymentStatus(varPaymentInfo.ph_status)}
                      </div>
                    </div>									
                  </div>
                  <div className="top-line"><p>최근 1년 결제 내역</p></div>
                  <div style={{height:"400px", overflowY:"scroll"}}>
                    {varPaymentList.map((payments,i)=>(
                      <div key={'payments_'+i} className="con-box">
                        <div className="txt-box">
                          <div className="date-line">
                            <div className="date">{GetPaymentDate(payments)}</div>
                            <p className="price">₩ {addThousandPoint(payments.ph_price)} 원</p>
                          </div>
                          <div className="info-line">{payments.mem_name} {ChangeMobileFormat(payments.mem_mobile)} <span> 👼🏻[{payments.ch_name}({PassedMonthsCode(payments.ch_birthday)})]</span></div>
                          <div className="flex">
                            <p>결제 유형</p>
                            <div>카드</div>
                          </div>
                          <div className="flex">
                            <p>결제 학기</p>
                            <div>{payments.sm_name}</div>
                          </div>
                          <div className="flex">
                            <p>결제 클래스</p>
                            <div>{payments.cl_name}</div>
                          </div>
                          <div className="flex">
                            <p>청구서 ID</p>
                            <div>{payments.ivc_id}</div>
                          </div>
                          <div className="flex">
                            <p>결제 상태</p>
                            <div className={GetPaymentClassStatus(payments.ph_status)}>
                              {GetPaymentStatus(payments.ph_status)}
                            </div>
                          </div>	
                        </div>								
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="btn-center" style={{display:"flex",justifyContent:"space-between"}}>
          <button onClick={()=>setShowPaymentHistory(false)} style={{width:"90px"}} className="btn line black">닫기</button>
        </div>
      </div>
    </div> 
  )
}
export default PaymentHisotry;